class Template {

    static #templates = {};

    static load(selector) {
        if(selector in Template.#templates) {
            return Template.#templates[selector];
        }
        let template = $(selector);
        template.removeClass('app-template');
        let html = template.wrap('<div>').parent().html();
        template.remove();
        let templateObj = new Template(html);
        Template.#templates[selector] = templateObj;
        return templateObj;
    }

    constructor(content) {
        this.node = $(content);
    }

    buildForEach(list, intoContainer, builderFn, transformFn) {
        let results = [];
        if (builderFn === undefined) {
            builderFn = this.build.bind(this);
        }

        return _.map(list, function (x) {
            let node = builderFn(x);
            intoContainer.append(node);
            if (transformFn !== undefined) {
                let obj = transformFn(node);
                results.push(obj);
            }
            return node;
        });
        return results;
    }

    build(params) {
        let node = this.node.clone();
        if (params !== undefined) {
            if (params.values !== undefined) {
                _.forEach(params.values, function (value, key) {
                    let valueNode = node.find(key);
                    if (value !== null && value !== undefined) {
                        valueNode.html(value);
                    } else {
                        valueNode.remove();
                    }
                });
            }
            if (params.style !== undefined) {
                node.addClass(params.style);
            }
        }
        node.removeClass('template');
        return node;
    }
}